module.exports = __webpack_public_path__ + "img/herz-stern.e09cf8c3.png";